/**
 * Indicates the Customer Title.
 */
export enum AreaMenu {
  Laboratory = 0,
  Admin = 1,
  CustomerAndCustomerGroup = 2,
  CustomerMember = 3,
  NoArea = 4,
}
